import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 80vh;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
